export enum ReviewedMixpanelEvents {
    USER_LOGGED_IN = 'user_logged_in',
    DEPOSIT_STARTED = 'deposit_started',
    DEPOSIT_COMPLETED = 'deposit_completed',
    DEPOSIT_FAILED = 'deposit_failed',
    PAGE_VIEWED = 'page_viewed',
    PAGE_LANDED = 'page_landed',
}
